import { NgModule, DoBootstrap } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from 'src/environments/environment';
import { XhrStrategyConfig, XhrAppConfigService, PtlXhrModule } from '@ptl/xhr';
import { EnvironmentService } from 'src/app/shared/services/environment.service';

/**
 * This module interacts with the exposed singleton XhrAppConfigService to
 * configure the application specific values associated with the provided xhr
 * strategies.
 */
@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    PtlXhrModule
  ]
})

export class PtlxhrConfigModule implements DoBootstrap {

  constructor(
    private customHttpClientService: XhrAppConfigService,
    private environmentService: EnvironmentService
  ) {

    /** Application Specific settings from the Library */
    const libraryConfig: XhrStrategyConfig = new XhrStrategyConfig(
      environment.infrastructure.axway.prePassKey,
      environment.infrastructure.axway.webServiceUrl,
      environment.infrastructure.axway.jwtBaseURL,
      this.environmentService.getEnvironment(),
      environment.infrastructure.googleCloud.baseUrl,
      environment.infrastructure.oauth,
      environment.infrastructure.oAMV4
    );
    this.customHttpClientService.custom = libraryConfig;

  }
  ngDoBootstrap() {

  }
}
